import { jsx as d } from "react/jsx-runtime";
import { c as x } from "../../../clsx-OuTLNxxd.js";
const y = "_flex_1taae_29", m = "_wrap_1taae_67", j = "_nowrap_1taae_70", b = "_shrink_1taae_88", a = {
  flex: y,
  "flex-row": "_flex-row_1taae_34",
  "flex-column": "_flex-column_1taae_37",
  "justify-start": "_justify-start_1taae_40",
  "justify-end": "_justify-end_1taae_43",
  "justify-center": "_justify-center_1taae_46",
  "justify-space-between": "_justify-space-between_1taae_49",
  "justify-space-around": "_justify-space-around_1taae_52",
  "align-start": "_align-start_1taae_55",
  "align-end": "_align-end_1taae_58",
  "align-center": "_align-center_1taae_61",
  "align-stretch": "_align-stretch_1taae_64",
  wrap: m,
  nowrap: j,
  "wrap-reverse": "_wrap-reverse_1taae_73",
  "is-full-width": "_is-full-width_1taae_79",
  "is-full-height": "_is-full-height_1taae_82",
  "flex-grow": "_flex-grow_1taae_85",
  shrink: b,
  "hide-on-mobile": "_hide-on-mobile_1taae_91",
  "gap-0": "_gap-0_1taae_99",
  "gap-1": "_gap-1_1taae_102",
  "gap-2": "_gap-2_1taae_105",
  "gap-3": "_gap-3_1taae_108",
  "gap-4": "_gap-4_1taae_111",
  "gap-5": "_gap-5_1taae_114",
  "gap-6": "_gap-6_1taae_117",
  "gap-7": "_gap-7_1taae_120",
  "gap-8": "_gap-8_1taae_123",
  "gap-9": "_gap-9_1taae_126",
  "gap-10": "_gap-10_1taae_129",
  "gap-11": "_gap-11_1taae_132",
  "gap-12": "_gap-12_1taae_135",
  "gap-14": "_gap-14_1taae_138",
  "gap-16": "_gap-16_1taae_141",
  "gap-18": "_gap-18_1taae_144",
  "gap-20": "_gap-20_1taae_147",
  "gap-24": "_gap-24_1taae_150",
  "gap-28": "_gap-28_1taae_153",
  "gap-32": "_gap-32_1taae_156",
  "gap-36": "_gap-36_1taae_159",
  "gap-40": "_gap-40_1taae_162",
  "gap-44": "_gap-44_1taae_165",
  "gap-48": "_gap-48_1taae_168",
  "gap-52": "_gap-52_1taae_171",
  "gap-56": "_gap-56_1taae_174",
  "gap-60": "_gap-60_1taae_177",
  "gap-64": "_gap-64_1taae_180",
  "gap-72": "_gap-72_1taae_183",
  "gap-80": "_gap-80_1taae_186",
  "gap-96": "_gap-96_1taae_189",
  "no-margin": "_no-margin_1taae_192",
  "dialog-overlay-show": "_dialog-overlay-show_1taae_1",
  "dialog-content-show": "_dialog-content-show_1taae_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1taae_1"
};
function $({
  children: e,
  direction: t = "row",
  justifyContent: g = "start",
  alignItems: p = "start",
  flexWrap: s = "wrap",
  className: l = "",
  isFullWidth: i = !1,
  isFullHeight: n = !1,
  gap: _,
  style: o,
  noMargin: r = !1,
  flexGrow: f = !1,
  hideOnMobile: c = !1,
  shrink: u = !1,
  ...w
}) {
  const h = x(
    a.flex,
    a[`flex-${t}`],
    a[`justify-${g}`],
    a[`align-${p}`],
    a[s],
    i && a["is-full-width"],
    n && a["is-full-height"],
    _ && a[`gap-${_}`],
    r && a["no-margin"],
    f && a["flex-grow"],
    c && a["hide-on-mobile"],
    u && a.shrink,
    l
  );
  return /* @__PURE__ */ d("div", { className: h, ...w, style: o, children: e });
}
export {
  $ as Flex
};
